import gql from "graphql-tag";

export const ADD_CHALLENGE = gql`
  mutation AddChallenge($clientName: String!, $challenge: ChallengeInput) {
    addChallenge(clientName: $clientName, challenge: $challenge) {
      _id
      clientName
      published
      title
      description
      difficulty
      duration
      commitment
      imageLink
      startDate
      communityId
      adminCommunityId
      type
      welcomeItem {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
        communityPostText
        communityPostImage
        adminCommunityPostText
        adminCommunityPostImage
      }
      endingItem {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
      }
      schedule {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
        startDay
        endDay
        notifications {
          title
          message
          time
        }
        community
        adminCommunity
        notificationTitle
        notificationMessage
        communityPostText
        communityPostImage
        adminCommunityPostText
        adminCommunityPostImage
      }
    }
  }
`;

export const UPDATE_CHALLENGE = gql`
  mutation UpdateChallenge(
    $challengeId: ID!
    $challengeUpdate: ChallengeInput!
  ) {
    updateChallenge(
      challengeId: $challengeId
      challengeUpdate: $challengeUpdate
    ) {
      _id
      clientName
      published
      title
      description
      difficulty
      duration
      commitment
      imageLink
      startDate
      communityId
      adminCommunityId
      type
      welcomeItem {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
        communityPostText
        communityPostImage
        adminCommunityPostText
        adminCommunityPostImage
      }
      endingItem {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
      }
      schedule {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
        startDay
        endDay
        notifications {
          title
          message
          time
        }
        community
        adminCommunity
        notificationTitle
        notificationMessage
        communityPostText
        communityPostImage
        adminCommunityPostText
        adminCommunityPostImage
      }
    }
  }
`;

export const PUBLISH_CHALLENGE = gql`
  mutation PublishChallenge($challengeId: ID!, $publish: Boolean) {
    publishChallenge(challengeId: $challengeId, publish: $publish) {
      _id
      published
    }
  }
`;

export const COPY_CHALLENGE = gql`
  mutation CopyChallenge($challengeId: ID!) {
    copyChallenge(challengeId: $challengeId) {
      _id
      clientName
      published
      title
      description
      difficulty
      duration
      commitment
      imageLink
      startDate
      communityId
      adminCommunityId
      type
      welcomeItem {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
        communityPostText
        communityPostImage
        adminCommunityPostText
        adminCommunityPostImage
      }
      endingItem {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
      }
      schedule {
        _id
        title
        description
        videoLink
        lessonText
        activities
        tasks {
          _id
          label
          passed
        }
        habits {
          _id
          title
          type
          description
          options
        }
        startDay
        endDay
        notifications {
          title
          message
          time
        }
        community
        adminCommunity
        notificationTitle
        notificationMessage
        communityPostText
        communityPostImage
        adminCommunityPostText
        adminCommunityPostImage
      }
    }
  }
`;

export const DELETE_CHALLENGE = gql`
  mutation DeleteChallenge($challengeId: ID!) {
    deleteChallenge(challengeId: $challengeId)
  }
`;

export const IMAGE_UPLOAD = gql`
  mutation UploadImage(
    $fileUrl: String!
    $documentId: String
    $collection: String!
    $fileName: String
  ) {
    uploadImage(
      fileUrl: $fileUrl
      documentId: $documentId
      collection: $collection
      fileName: $fileName
    )
  }
`;
